/**
 * Formats a venue label for consumption-place display (ITT-781).
 * @param {{ name?: string, formattedAddress?: string }} venue
 * @returns {string}
 */
export function formatVenueConsumptionLabel(venue) {
  const name = typeof venue?.name === 'string' ? venue.name.trim() : '';
  const formattedAddress = typeof venue?.formattedAddress === 'string'
    ? venue.formattedAddress.trim()
    : '';

  if (name && formattedAddress) {
    return `${name} (${formattedAddress})`;
  }
  if (name) {
    return name;
  }
  if (formattedAddress) {
    return formattedAddress;
  }
  return 'Venue';
}
